import { PaymentTerms } from '@received/pricing-model';

export const DUE_UPON_RECEIPT_LABEL = 'due upon receipt';
export const DUE_UPON_USAGE_LABEL = 'due upon usage';

export const defaultNetTerms = 30;

export const netTermsSelect = (isUsageProduct?: boolean) => [
	{
		label: DUE_UPON_RECEIPT_LABEL,
		value: PaymentTerms.DUE_UPON_RECEIPT,
	},
	{
		label: 'net 30',
		value: 30,
	},
	{
		label: 'net 45',
		value: 45,
	},
	{
		label: 'net 60',
		value: 60,
	},
	{
		label: 'net 90',
		value: 90,
	},
];
